export default __webpack_public_path__ + "static/media/instagram.719f2b3f.svg";